<template>
	<div v-if="isLoaded">
		<div class="win_bg">
			<div style="display: flex;align-items: center;position: absolute;top: 0;left: 0;">
				<el-image style="width: 150px;padding: 11px 0px 11px 11px;"
					:src="require('@/assets/logo-xjj.png')"></el-image>
				<!-- <div style="font-size: 20px;" class="u-p-l-10">星剪辑</div> -->
			</div>

			<div class="title" style="font-weight: 550;display: flex;align-items: center;"><a
					style="background-color: rgb(49, 60, 217);color: #fff;border-radius: 1em;padding: 3px 0.5em;font-size: 0.7em;">一键!</a>制作
			</div>
			<div class="title" style="font-weight: 550;">星剪辑短视频</div>

			<div style="margin-top: 60px;width: 50%;max-width: 40em;min-width: 20em;">
				<el-row :gutter="15">
					<el-col :xs="12" :sm="12" :lg="6" style="margin-bottom: 20px;">
						<el-button style="border-radius: 50px;font-weight: 600;width: 100%;" type="warning" plain
							@click="$router.push('/user/index')">进入网页版</el-button>
					</el-col>
					<el-col :xs="12" :sm="12" :lg="6" style="margin-bottom: 20px;">
						<el-button style="border-radius: 50px;font-weight: 600;width: 100%;" type="danger" plain
							@click="$router.push('/user/vip')">购买会员</el-button>
					</el-col>
					<el-col :xs="12" :sm="12" :lg="6" style="margin-bottom: 20px;">
						<el-button style="border-radius: 50px;font-weight: 600;width: 100%;" type="success" plain
							@click="$router.push('/user/qc')">一键剪辑</el-button>
					</el-col>
					<el-col :xs="12" :sm="12" :lg="6" style="margin-bottom: 20px;">
						<el-button style="border-radius: 50px;font-weight: 600;width: 100%;" type="success" plain
							@click="$router.push('/user/qsy')">免费去水印</el-button>
					</el-col>

				</el-row>
			</div>
			<!-- <div style="margin-top: 50px;display: flex;justify-content: center;flex-wrap: wrap;">
        <el-button style="border-radius: 50px;margin: 5px 15px;font-weight: 600;padding: 15px 40px;" type="danger" plain
          @click="$router.push('/user/index')">进入网页版</el-button>
        <el-button style="border-radius: 50px;margin: 5px 15px;font-weight: 600;padding: 15px 40px;" type="success"
          @click="downapp">下载 APP</el-button>
      </div> -->

		</div>

		<div
			style="position: fixed;bottom: 10px;right: 0;left: 0;display: flex;justify-content: center;color: #666;font-size: 13px;flex-direction: column;">
			<div style="display: flex;flex-wrap: wrap;justify-content: center;">
				Copyright © 2023 All Rights Reserved
				<div>星剪辑</div>
			</div>
			<div style="text-align: center;">
				<el-link href="https://beian.miit.gov.cn" target="_blank" style="font-size: 13px;">
					皖ICP备2022011223号</el-link>
			</div>

		</div>

		<div v-if="wx" class="wx">
			<div style="position: absolute;right: 0;">
				<div style="display: flex;justify-content: end;margin: 10px 30px 0px 0px;">
					<i class="el-icon-top-right" style="font-size: 40px;color: #fff;"></i>
				</div>
				<div style="color: #fff;font-size: 27px;margin:20px 40px 0px 0px;">点击右上角 ···<br>在手机浏览器中打开</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		components: {

		},
		// 定义属性
		data() {
			return {
				wx: false,
				isLoaded: true,
			}
		},
		// 计算属性，会监听依赖属性值随之变化
		computed: {},
		// 监控data中的数据变化
		watch: {},
		// 方法集合
		methods: {
			downapp() {
				this.$message('正在开发中...')
				//是否是微信浏览器
				// if (/(micromessenger)/i.test(navigator.userAgent)) {
				// 	this.wx = true
				// 	return
				// }
				// if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				// 	location.href = 'https://apps.apple.com/cn/app/%E8%B5%B7%E5%8F%B7%E4%BA%91/id1609731577'
				// } else {
				// 	location.href = 'https://video.kissxx.cn/qhy.apk'
				// }
			}
		},
		// 生命周期 - 创建完成（可以访问当前this实例）
		created() {
			// this.$router.push('/user/index');
		},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {

		},
		beforeCreate() {}, // 生命周期 - 创建之前
		beforeMount() {}, // 生命周期 - 挂载之前
		beforeUpdate() {}, // 生命周期 - 更新之前
		updated() {}, // 生命周期 - 更新之后
		beforeDestroy() {}, // 生命周期 - 销毁之前
		destroyed() {}, // 生命周期 - 销毁完成
		activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	}
</script>

<style scoped>
	@font-face{
		font-family:'dd-font';
		src:url('../../assets/fonts/dd.ttf');
		font-weight: normal;
		font-style: normal;
	}
	.wx {
		position: fixed;
		z-index: 9999;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(61, 61, 61, 0.6);
	}

	.win_bg {
		height: 100%;
		width: 100%;
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #f3f4f6;
		/* background: url("../../assets/bg.jpeg") center center no-repeat; */
		background: url('../../assets/bg.jpeg') center center no-repeat;
		background-size: 140% 100%;
		font-family: dd-font;
	}

	@media (max-width: 9999px) {
		.title {
			font-size: 100px;
		}
	}

	@media (max-width: 1200px) {
		.title {
			font-size: 90px;
		}
	}

	@media (max-width: 992px) {
		.title {
			font-size: 75px;
		}
	}

	@media (max-width: 768px) {
		.title {
			font-size: 60px;
		}
	}

	@media (max-width: 350px) {
		.title {
			font-size: 40px;
		}
	}
</style>